import { AttachmentType } from '@sdir/httpclient/lib/clients/aps/application';

export const AttachmentTypeTranslationMap: Record<AttachmentType, string> = {
  [AttachmentType.Application]: 'app.addfiles.types.application',
  [AttachmentType.SeagoingTime]: 'app.addfiles.types.seagoing',
  [AttachmentType.Course]: 'app.addfiles.types.course',
  [AttachmentType.Education]: 'app.addfiles.types.education',
  [AttachmentType.Photo]: 'app.addfiles.types.photo',
  [AttachmentType.Signature]: 'app.addfiles.types.signature',
  [AttachmentType.Na]: 'app.addfiles.types.na',
  [AttachmentType.PhotoCropped]: 'app.addfiles.types.photocropped',
  [AttachmentType.SignatureCropped]: 'app.addfiles.types.signaturecropped',
  [AttachmentType.Assessment]: 'app.addfiles.types.Assessment',
  [AttachmentType.AdditionalCompetence]: 'app.addfiles.types.AdditionalCompetence',
  [AttachmentType.HealthCheck]: 'app.addfiles.types.HealthCheck',
  [AttachmentType.Certificate]: 'app.addfiles.types.Certificate',
  [AttachmentType.ForeignCourse]: 'app.addfiles.types.ForeignCourse',
  [AttachmentType.ForeignId]: 'app.addfiles.types.ForeignId',
  [AttachmentType.NorwegianPassportOrId]: 'app.addfiles.types.NorwegianPassportOrId',
  [AttachmentType.Letter]: 'app.addfiles.types.Letter',
  [AttachmentType.IssuedCertificate]: 'app.addfiles.types.IssuedCertificate',
  [AttachmentType.Confirmation]: 'app.addfiles.types.Confirmation',
  [AttachmentType.OverRule]: 'app.addfiles.types.OverRule',
  [AttachmentType.NorwegianPassportOrId]: 'app.addfiles.types.NorwegianPassportOrId',
};
